import type { FC } from 'react';
import React, { Fragment } from 'react';
import type { ApolloErrorInterop } from '@confluence/apollo-relay-interop/entry-points/ApolloErrorInterop.ts';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import StatusWarningIcon from '@atlaskit/icon/core/status-warning';

import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay.ts';

const i18n = defineMessages({
	error: {
		id: 'space-directory.error.message',
		defaultMessage: 'We’re having trouble loading the spaces. Try refreshing now.',
		description:
			'Shown when Space directory fails to load initially OR fails to load additional spaces',
	},
});

const errorMessageStyle = css({
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	marginTop: token('space.250'),
	color: token('color.text.subtle'),
});

export const ErrorMessage: FC<{ apolloError?: ApolloErrorInterop }> = ({ apolloError }) => (
	<Fragment>
		{apolloError && <ErrorDisplay error={apolloError} />}
		{!apolloError?.extraInfo?.isWatchedError ? (
			<div css={errorMessageStyle}>
				<StatusWarningIcon spacing="spacious" color={token('color.icon.danger')} label="" />
				<FormattedMessage {...i18n.error} />
			</div>
		) : null}
	</Fragment>
);
